import React, { useRef, useEffect } from 'react';

import * as styles from './GalleryVideo.module.scss';

export default function GalleryVideo({ src, index, current }) {
  const video = useRef(null);

  useEffect(() => {
    if (index !== current) {
      video.current.pause();
      video.current.currentTime = 0;
    }
  }, [current]);

  return (
    <div className={styles.videoWrapper}>
      <video ref={video} controls className={styles.video}>
        <source src={src} type="video/mp4" />
      </video>
    </div>
  );
}
